import ArticleHeader from 'components/article-header/ArticleHeader';
import { ContentWithSidebar, Content, Sidebar } from 'components/content-with-sidebar';
import Header from 'components/content-with-sidebar/ContentWithSidebarHeader';
import PageNavigation from 'components/page-navigation/PageNavigation';
import TableOfContents from 'components/table-of-contents/TableOfContents';
import RichText from 'components/rich-text/RichText';
import ContentArea from 'components/content-area/ContentArea';

import { ILargeDocumentsPage } from 'source/NFR.types';

const LargeDocumentsPage: React.FC<ILargeDocumentsPage> = ({
  content,
  header,
  ingress,
  pageNavigation,
  tableOfContents,
  title,
  contentArea
}) => (
  <ContentWithSidebar theme="largeDocuments" className="large-documents-page">
    <Header>
      {title && <h1>{title}</h1>}
      {ingress && (
        <div className="large-documents-page--ingress">
          <p>{ingress}</p>
        </div>
      )}
    </Header>
    <Sidebar>
      <TableOfContents {...tableOfContents} />
    </Sidebar>
    <Content className="large-documents-page--content">
      <ArticleHeader {...header} />

      <RichText {...content} />
      <ContentArea {...contentArea} />
      {pageNavigation && <PageNavigation {...pageNavigation} />}
      <div className="large-documents-page--footer"></div>
    </Content>
  </ContentWithSidebar>
);

LargeDocumentsPage.displayName = 'LargeDocumentsPage';

export default LargeDocumentsPage;
